import { useEffect, useRef } from 'react';
import type Pubnub from 'pubnub';
import type PubnubFacade from 'common/utils/facades/pubnub-facade';

type UsePubnubChannelOptions = {
	pubnub?: PubnubFacade;
	channel?: string;
	enabled?: boolean;
	onMessage: (event: Pubnub.MessageEvent) => void;
};

export const usePubnubChannel = ({ pubnub, channel, enabled = true, onMessage }: UsePubnubChannelOptions): void => {
	const onMessageRef = useRef(onMessage);

	useEffect(() => {
		onMessageRef.current = onMessage;
	}, [onMessage]);

	useEffect(() => {
		if (!enabled || !pubnub || !channel) {
			return undefined;
		}

		pubnub.subscribe(channel);
		pubnub.addListeners({
			message(messageEvent: Pubnub.MessageEvent) {
				onMessageRef.current(messageEvent);
			},
		});

		return () => {
			pubnub.removeListeners();
			pubnub.unsubscribe(channel);
		};
	}, [pubnub, channel, enabled]);
};
